// Add your JS customizations here

// Hamburger Menu Animation (Bootstrap 4 & 5 compatible)
document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.custom-hamburger');
  const navCollapse = document.getElementById('navbarNavDropdown');

  if (hamburger && navCollapse) {
    // Check if jQuery and Bootstrap are loaded (Bootstrap 4)
    if (typeof jQuery !== 'undefined' && jQuery.fn.collapse) {
      // Bootstrap 4 with jQuery
      jQuery('#navbarNavDropdown').on('show.bs.collapse', function() {
        hamburger.setAttribute('aria-expanded', 'true');
      });

      jQuery('#navbarNavDropdown').on('hide.bs.collapse', function() {
        hamburger.setAttribute('aria-expanded', 'false');
      });
    } else {
      // Bootstrap 5 without jQuery
      navCollapse.addEventListener('show.bs.collapse', function() {
        hamburger.setAttribute('aria-expanded', 'true');
      });

      navCollapse.addEventListener('hide.bs.collapse', function() {
        hamburger.setAttribute('aria-expanded', 'false');
      });
    }
  }
});
